module.exports = __webpack_public_path__ + "static/media/27OCHA12.9a8260e7.jpg";